import { useApiMutation } from "./use-api-mutation";

export const useUpdateCurrentUser = () => {
  return useApiMutation(
    "patch",
    "/users/me",
  );
};
